import { render, staticRenderFns } from "./RenovacionRapidaComponent.vue?vue&type=template&id=74b84b76&scoped=true"
import script from "./RenovacionRapidaComponent.vue?vue&type=script&lang=js"
export * from "./RenovacionRapidaComponent.vue?vue&type=script&lang=js"
import style0 from "./RenovacionRapidaComponent.vue?vue&type=style&index=0&id=74b84b76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b84b76",
  null
  
)

export default component.exports